export function dynamicParameters(obj) {
  let dynamicParameter = ''

  for (let [key, value] of Object.entries(obj)) {
    if (![undefined, 'undefined', null, 'null'].includes(value)) {
      dynamicParameter = dynamicParameter + `&${key}=${value}`
    }
  }

  return dynamicParameter.substring(1)
}
